import script from "./newsdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./newsdetail.vue?vue&type=script&setup=true&lang=js"

import "./newsdetail.vue?vue&type=style&index=0&id=97d97af4&lang=less"
import "./newsdetail.vue?vue&type=style&index=1&id=97d97af4&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/www.7pa.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97d97af4"]])

export default __exports__